/**
 * This helper object contains methods to generate the links required for navigation
 */
import NavigationData from "../conf/navigation.json";
import SpecialNavData from "../conf/special-navigation.json";
import JobOffersURLData from "../conf/job-offers-urls.json";
import ServicesDescriptionsURLData from "../conf/services-urls.json";
import PartnersURLData from "../conf/partners-urls.json";
import SlidesURLData from "../conf/slides-urls.json";

const NavigationHelper = {
  rootURL: "/",
  /**
   * Adds a trailing slash to a URL if it doesn't already end with one.
   * @param {string} url - The URL to modify.
   * @returns {string} The modified URL.
   */
  addTrailingSlash: function (url) {
    if (url.charAt(url.length - 1) !== "/") {
      return url + "/";
    } else {
      return url;
    }
  },
  convertHubSpotSlug: function (origSlug) {
    return origSlug.replace(/^(fr-fr|en-en|es-es)\//, "");
  },
  useGeneratePageURL: function (lang, pageKey, itemKey = null) {
    const langRootURL = `${this.rootURL}${lang}/`;
    let returnedURL;
    try {
      if (
        SpecialNavData.hasOwnProperty(pageKey) &&
        SpecialNavData[pageKey].hasOwnProperty(lang)
      ) {
        returnedURL = SpecialNavData[pageKey][lang];
      } else {
        if (NavigationData[pageKey] && NavigationData[pageKey][lang]) {
          returnedURL = NavigationData[pageKey][lang].length
            ? `${langRootURL}${NavigationData[pageKey][lang]}/`
            : langRootURL;
        } else {
          returnedURL = langRootURL;
        }
      }
    } catch (error) {
      returnedURL = langRootURL;
      if (process.env.NODE_ENV === "development") {
        console.warn(
          `Trouble to generate the page URL with ${lang} and ${pageKey}`,
        );
        console.warn(error);
      }
    }

    if (itemKey !== null) {
      switch (pageKey) {
        // Job offers
        case "job":
          if (JobOffersURLData[itemKey] && JobOffersURLData[itemKey][lang]) {
            const jobItemKey = JobOffersURLData[itemKey][lang];
            returnedURL += `${jobItemKey}/`;
          }
          break;
        // Services descriptions
        case "solutions":
          if (
            ServicesDescriptionsURLData[itemKey] &&
            ServicesDescriptionsURLData[itemKey][lang]
          ) {
            const offerItemKey = ServicesDescriptionsURLData[itemKey][lang];
            returnedURL += `${offerItemKey}/`;
          }
          break;
        // Slides
        case "slide":
          if (SlidesURLData[itemKey] && SlidesURLData[itemKey][lang]) {
            returnedURL = SlidesURLData[itemKey][lang];
          }
          break;
        // Partners
        case "partner":
          if (PartnersURLData[itemKey] && PartnersURLData[itemKey][lang]) {
            const partnerItemKey = PartnersURLData[itemKey][lang];
            returnedURL += `${partnerItemKey}/`;
          }
          break;
        // Blog posts
        case "blogpost":
          const postItemKey = this.convertHubSpotSlug(itemKey);
          returnedURL += `${postItemKey}/`;
          break;
        // Blog category
        case "blogcategory":
          const catItemKey = itemKey.toLowerCase();
          returnedURL += `${catItemKey}/`;
          break;
        // Blog tag
        case "blogtag":
          const tagItemKey = itemKey.toLowerCase();
          returnedURL += `${tagItemKey}/`;
          break;
        default:
          returnedURL += `${itemKey}/`;
          break;
      }
    }

    return returnedURL;
  },
};
export default NavigationHelper;
